import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('en_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('en_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity) => {
    setItems(prev => {
      const existing = prev.find(i => i.product_id === product._id);
      if (existing) return prev.map(i => i.product_id === product._id ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, { product_id: product._id, name: product.name, price: product.price, image: product.primary_image, min_order_qty: product.min_order_qty, colours: product.colours, quantity }];
    });
  };

  const updateQty = (product_id, quantity, min_order_qty = 1) => {
    // Fix #7: enforce min_order_qty on manual updates too
    if (quantity <= 0) return removeItem(product_id);
    const enforced = Math.max(min_order_qty, quantity);
    setItems(prev => prev.map(i => i.product_id === product_id ? { ...i, quantity: enforced } : i));
  };

  const removeItem = (product_id) => setItems(prev => prev.filter(i => i.product_id !== product_id));

  const clearCart = () => {
    setItems([]);
    localStorage.removeItem('en_cart');
  };

  const totalItems = items.reduce((s, i) => s + i.quantity, 0);
  const totalAmount = items.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, totalItems, totalAmount }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
